import { signal } from '@preact/signals-react'

export const installationListSignal = signal([])
export const installationListLoadedSignal = signal(false)
export const installationListErrorSignal = signal(null)